import config from '../config';
import api from './api';

// Service pour gérer les utilisateurs
class UsersService {
  constructor() {
    this.baseURL = `${config.API_URL}/api/admin/users`;
  }

  // Récupérer tous les utilisateurs avec pagination et recherche
  async getAllUsers(page = 1, limit = 10, search = '') {
    try {
      const params = new URLSearchParams();
      if (page) params.append('page', page);
      if (limit) params.append('limit', limit);
      if (search) params.append('search', search);

      const response = await api.get(`${this.baseURL}?${params.toString()}`);
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error);
      throw error;
    }
  }

  // Récupérer un utilisateur par ID avec toutes ses données
  async getUserById(userId) {
    try {
      const response = await api.get(`${this.baseURL}/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'utilisateur:', error);
      throw error;
    }
  }

  // Récupérer le panier d'un utilisateur
  async getUserCart(userId) {
    try {
      const response = await api.get(`${this.baseURL}/${userId}/cart`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du panier:', error);
      throw error;
    }
  }

  // Récupérer les commandes d'un utilisateur
  async getUserOrders(userId) {
    try {
      const response = await api.get(`${this.baseURL}/${userId}/orders`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des commandes:', error);
      throw error;
    }
  }

  // Récupérer les adresses d'un utilisateur
  async getUserAddresses(userId) {
    try {
      const response = await api.get(`${this.baseURL}/${userId}/addresses`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des adresses:', error);
      throw error;
    }
  }

  // Mettre à jour un utilisateur
  async updateUser(userId, userData) {
    try {
      const response = await api.put(`${this.baseURL}/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'utilisateur:', error);
      throw error;
    }
  }

  // Supprimer un utilisateur
  async deleteUser(userId) {
    try {
      const response = await api.delete(`${this.baseURL}/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'utilisateur:', error);
      throw error;
    }
  }

  // Envoyer une notification personnalisée à un utilisateur
  async sendNotification(userId, payload) {
    try {
      const response = await api.post(`${this.baseURL}/${userId}/notify`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi de la notification:', error);
      throw error;
    }
  }

  // Test de connexion simple
  async testConnection() {
    try {
      const response = await api.get(`${config.API_URL}/api/categories`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Erreur de test de connexion:', error);
      return { success: false, error: error.message };
    }
  }
}

export const usersService = new UsersService();
